import 'owl.carousel'
import { owlCarouselOptions } from './configs'

/**
 * Owl Carousel init
 */
jQuery('.carousel-container').each(function(){
	const $container = jQuery(this)
	const $carousel = $container.find('.carousel')

	const owlCarouselCustomOptions = {
		items:           $container.data('items') ? +$container.data('items') : owlCarouselOptions.items,
		margin:          $container.data('margin') ? +$container.data('margin') : owlCarouselOptions.margin,
		smartSpeed:      $container.data('smart-speed') ? +$container.data('smart-speed') : owlCarouselOptions.smartSpeed,

		autoplay:        $container.data('autoplay') ? $container.data('autoplay') : owlCarouselOptions.autoplay,
		autoplayTimeout: $container.data('timeout') ? +$container.data('timeout') : owlCarouselOptions.autoplayTimeout,
		loop:            $container.data('loop') ? $container.data('loop') : owlCarouselOptions.loop,
		slideBy:         $container.data('slide-by') ? $container.data('slide-by') : owlCarouselOptions.slideBy,

		nav:             $container.data('nav') ? $container.data('nav') : owlCarouselOptions.nav,
		navText:         ['<i></i>', '<i></i>'],

		dots:            $container.data('dots') ? $container.data('dots') : owlCarouselOptions.dots,
		dotsContainer:   $container.data('dots-container') ? $container.data('dots-container') : 0,

		responsive:      $container.data('responsive') ? $container.data('responsive') : 0
	}


	const options = {
		...owlCarouselOptions,
		...owlCarouselCustomOptions
	}

	$carousel.owlCarousel(options)
})
